import * as React from "react";
import {Modal} from "semantic-ui-react";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import {FC, useState} from "react";

type AboutModalProps = {
    open: boolean;
}

export const AboutModal: FC<AboutModalProps> = ({open = false}) =>  {
    const [isOpen, setIsOpen] = useState(open)

    return (
        <Modal open={isOpen} trigger={<Dropdown.Item>About</Dropdown.Item>}
               onOpen={(e) => setIsOpen(true)}
               onClose={(e) => setIsOpen(false)}
        >
            <Modal.Header>What's this?</Modal.Header>
            <Modal.Content>
                <p>This app teaches you Hiragana and Katakana. You will be shown words that consist of very few
                    characters. As you get better at reading their pronunciation, new characters will be
                    introduced.</p>
                <p>You also will see meanings of these words and if applicable the corresponding kanji. This is only
                    to sate potential curiosity. The application is not optimized to teach you the meanings of
                    words. Focus on learning on the reading of the words only.</p>
                <p>Your progress will be stored locally in your browser. You can close and open the browser and restart
                    your device and your sessions will pick right up where you left off.</p>
                <br/><br/>
                <p style={{color: 'grey'}}>Acknowledgment: This app wouldn't have been possible without the <a
                    href="http://www.edrdg.org/jmdict/edict_doc.html">JMdict/EDICT project</a></p>
            </Modal.Content>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/AboutModal.tsx